export const QUERY_KEY_ILT_REGISTRATIONS = 'ILT_REGISTRATIONS'
